import Tooltip from '@mui/material/Tooltip';
import styles from "./styles/Styles.module.css";

const BasicTooltip = (props) => (
    <Tooltip
        {...props}
        classes={{
            tooltip: styles.basicTooltip,
            popper: styles.tooltipPopper
        }}
    />
);

export default BasicTooltip;